module.exports = __webpack_public_path__ + "img/Wolkentupfer.c266c994.jpg";